import * as React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./Dashboard";
import TableSectionMainPage from "./TableSection";
import Approvals from "./Approvals";
import { AdContext } from "../context/AdContext";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import styles from "../styles/layout.module.css";

function Layout() {
  const { section, email } = React.useContext(AdContext);
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState<boolean>(false);

  const toggleSidebar = React.useCallback(() => setSidebarCollapsed((c) => !c), []);

  return (
    <div className={styles.appShell}>
      <Header onToggleSidebar={toggleSidebar} sidebarCollapsed={sidebarCollapsed} />
      <Sidebar collapsed={sidebarCollapsed} />
      <main className={`${styles.mainContent}${sidebarCollapsed ? ` ${styles.sidebarCollapsed}` : ""}`}>
        <div className={styles.pageContent}>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  {section === "dashboard" && <Dashboard email={email} />}
                  {section === "table" && <TableSectionMainPage />}
                </>
              }
            />
            <Route path="/approvals" element={<Approvals />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default Layout;
